/// <reference path="core/services/tokenvalidate/tokenvalidation.service.ts" />
import { Component, OnInit, OnDestroy, ViewChild, Inject, Renderer2, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { User } from './core/models/dealer.model';
import { DataService } from '@tr/target-retail';
//import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, fromEvent, merge } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../environments/environment';
import { buildinfo } from '../environments/buildinfo';
import { TokenvalidationService } from './core/services/tokenvalidate/tokenvalidation.service';
import { TermsConditionService } from './core/services/termsConditions/terms-condition.service';
import { ResourceService } from './core/services/resource/resource.service';
import { ConfigurationService } from './core/services/configuration/configurations.service';
import { ConfigFeatureFlagSettingsManager } from './shared/services/configurationsettings/configFeatureFlagSetting.manager'
import { FeatureFlagKeys } from './shared/FeatureFlag'
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    isAuthenticated: boolean;
    currentUser: User;
    subscription: Subscription;
    campaignSubscription: Subscription;
    termsConditionMessage: string;
    internalRoute: boolean;
    resources: any;
    lastSessionRenewTime: any;
    currentTime: any;
    ResetCount: number = 0;
    @ViewChild('terms_condition', { static: false }) private termAndConditionContent;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private router: Router,
        private dataService: DataService,
        private spinner: NgxSpinnerService,
        private modalService: NgbModal,
        private termsConditionService: TermsConditionService,
        private resourceService: ResourceService,
        private configurationService: ConfigurationService,
        private configFeatureFlagSettingsManager: ConfigFeatureFlagSettingsManager
    ) {
        const routePath = window.location.pathname.replace(/\\|\//g, '');
        this.spinner.show();
        this.initializeDataService(routePath);
        this.handleInternalRoute(routePath);
        this.setSessionObjects();
        this.setBrandList();
        this.logDebugInfo(routePath);
        this.addAnalyticsScript();        
        this.initGoogleAnalytics();
        this.handleConquestEnrollment();
        this.subscribeToCampaignInfo();
        this.subscribeToTabChange();
        this.hideSpinnerWithDelay();
    }

    private initializeDataService(routePath: string): void {
        DataService.packageBaseUrl = "/tr-analytics-api";
        DataService.campaignBuilderUrl = "/tr-api/Campaign/Execute";
        DataService.assetsBasePath = "/dist/assets/core/";
        DataService.weDamapiUrl = environment.webEnrollmentDAMAPI;
        DataService.dealerId = TokenvalidationService.tokenInformation["PartDealerId"] ? TokenvalidationService.tokenInformation["PartDealerId"] : '';
        DataService.oemId = TokenvalidationService.tokenInformation["DHOEMId"]
            ? TokenvalidationService.tokenInformation["DHOEMId"]
            : environment.dataHubOEMS[TokenvalidationService.tenant];
    }

    private handleInternalRoute(routePath: string): void {
        if (!this.internalRoute) {
            DataService.selectedMenu = routePath;
            let navigationInfo = {
                eventType: "NavigationMenu",
                MenuName: routePath
            };
            parent.parent.postMessage(navigationInfo, '*');
        }
    }

    private setSessionObjects(): void {
        DataService.sessionObject = TokenvalidationService.tokenInformation;
        DataService.sessionObject.trCoreApi = "/tr-api/";
        DataService.sessionObject.trAnalyticsApi = "/tr-analytics-api/";
        DataService.sessionObject.cbApi = "/cb-api/";
    }

    private setBrandList(): void {
        if (TokenvalidationService.tokenInformation['brand'] != null) {
            DataService.brandList = (TokenvalidationService.tokenInformation['brand'] == '')
                ? ['']
                : TokenvalidationService.tokenInformation['brand'].split();
        }
    }

    private logDebugInfo(routePath: string): void {
        if (!environment.production) {
            console.log("AppURL" + this.router.url);
            console.log("Selected Route is : " + routePath);
            console.log(`DataService parameters dealerId: ${TokenvalidationService.tokenInformation["PartDealerId"]}  oemId: ${TokenvalidationService.tokenInformation["DHOEMId"]}`)
            console.log(DataService.brandList);
            console.log("Token info", TokenvalidationService.tokenInformation);
        }
    }

    private addAnalyticsScript(): void {

        let clarityId = environment.production ? "ryf5w2kepb" : "rxfrdi535u";
        let userName = TokenvalidationService.tokenInformation["UserName"];
        let userRole = TokenvalidationService.tokenInformation['Role'].map(role => role.toLowerCase()).join(',');
        let tenant = TokenvalidationService.tenant;
        let dealerName = TokenvalidationService.tokenInformation["OrgName"];

        let scriptCode = ` (function(c,l,a,r,i,t,y){
			c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
			t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
			y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
			clarity("set", "user_name", "` + userName + `");
			clarity("set", "user_role", "` + userRole + `");
			clarity("set", "tenant", "` + tenant + `");
			clarity("set", "dealer_name", "` + dealerName + `");
        })(window, document, "clarity", "script", "` + clarityId + `");`;

        const script = document.createElement('script');
        script.type = 'application/javascript';
        script.textContent = scriptCode;
        document.head.appendChild(script);

    }

    private handleConquestEnrollment(): void {
        if (environment.conquestEnrollmentConditions[TokenvalidationService.tenant]) {
            let _contractOptions = TokenvalidationService.tokenInformation['ContractOptions']
                ? TokenvalidationService.tokenInformation['ContractOptions'].toLowerCase().replace(/\s/g, '')
                : "";
            let _contractCondition = TokenvalidationService.tokenInformation['ContractCondition']
                ? TokenvalidationService.tokenInformation['ContractCondition'].toLowerCase().replace(/\s/g, '')
                : "";
            let _contractStatus = TokenvalidationService.tokenInformation['ContractStatus']
                ? TokenvalidationService.tokenInformation['ContractStatus'].toLowerCase().replace(/\s/g, '')
                : "";

            TokenvalidationService.creativeType = _contractOptions;
            DataService.dealerConquestEnrollment = (_contractOptions === "ownersandconquest") ? true : false;
            DataService.conquestEnrollmentStatus = TokenvalidationService.conquestEnrollmentStatus = "NA";
            TokenvalidationService.isLiteDealer = !DataService.dealerConquestEnrollment;

            if ((_contractOptions === "owners" && _contractCondition === "activecontract" && _contractStatus === "stop")) {
                DataService.conquestEnrollmentStatus = TokenvalidationService.conquestEnrollmentStatus = "UP";
                TokenvalidationService.isLiteDealer = true;
            }
            else if ((_contractOptions === "ownersandconquest" && _contractCondition === "activecontract" && _contractStatus === "stop")) {
                DataService.conquestEnrollmentStatus = TokenvalidationService.conquestEnrollmentStatus = "DP";
                TokenvalidationService.creativeType = "owners";
                TokenvalidationService.isLiteDealer = false;
            }
            else if ((_contractOptions === "ownersandconquest" && _contractCondition === "activecontract" && _contractStatus === "active")) {
                DataService.conquestEnrollmentStatus = TokenvalidationService.conquestEnrollmentStatus = "A";
                TokenvalidationService.isLiteDealer = false;
            }
            else if ((_contractOptions === "owners" && _contractCondition === "activecontract" && _contractStatus === "active")) {
                DataService.conquestEnrollmentStatus = TokenvalidationService.conquestEnrollmentStatus = "NA";
                TokenvalidationService.isLiteDealer = true;
            }
        }
        else {
            DataService.dealerConquestEnrollment = true;
            DataService.conquestEnrollmentStatus = TokenvalidationService.conquestEnrollmentStatus = "A";
            DataService.brandList = [TokenvalidationService.tenant.replace('TR', '')];
            TokenvalidationService.creativeType = "";
            TokenvalidationService.isLiteDealer = false;
        }
    }

    private subscribeToCampaignInfo(): void {
        this.campaignSubscription = this.dataService.campaignInfoEmitter.subscribe((result) => {
            if (result) {
                //console.log(result);
                this.router.routeReuseStrategy.shouldReuseRoute = function () {
                    return false;
                }
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate(['campaign/' + result.templateId])
            }
        });
    }

    private subscribeToTabChange(): void {
        this.subscription = this.dataService.tabChangeEmitter.subscribe((result) => {
            if (result) {
                let navigationInfo = {
                    eventType: "NavigationMenu",
                    MenuName: result
                };
                if (!environment.production) {
                    console.log("ROUTE:", result);
                    console.log('lease end', this.dataService);
                }
                parent.parent.postMessage(navigationInfo, '*');
                this.internalRoute = true;
                DataService.selectedMenu = result;
                if (result.toLowerCase() != "contactus") {
                    this.router.navigate(['/' + result]);
                }
            }
        });
    }

    private hideSpinnerWithDelay(): void {
        setTimeout(() => {
            this.spinner.hide();
        }, 2000);
    }

    title = 'TargetRetail';

    ngOnInit(): void {
        this.resources = this.resourceService.resourceInformation.Resources;

        const mousemoveEvent = fromEvent(document, 'mousemove');
        const keyboardEvent = fromEvent(document, 'keydown');
        const allEvents = merge(
            mousemoveEvent, keyboardEvent
        )

        this.subscription = allEvents.subscribe(e => {
            this.currentTime = new Date();
            let sessionReset = {
                eventType: "sessionReset",
                time: Number(Date.now())
            };
            parent.parent.postMessage(sessionReset, '*');
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    @HostListener('window:message', ['$event']) onMessage(event) {
        if (event.data && event.data.eventType === 'TRNavigation') {
            if (event.data.menuName) {
                this.initGoogleAnalytics(event.data.menuName);
                this.router.routeReuseStrategy.shouldReuseRoute = function () {
                    return false;
                }
                this.router.onSameUrlNavigation = 'reload';
                const routePath = event.data.menuName;
                if (this.dataService) this.dataService.changeMenu(routePath);
            }
        }
    }
    //Not using
    checkWECondition() {
        this.configFeatureFlagSettingsManager.featureFlag(FeatureFlagKeys.EnableWETermsConditionsCheckKey) ? this.checkTermsCondition() : console.log("WE T&C Disabled");
        //this.configurationService.getConfigurations(TokenvalidationService.tenant, 'EnableWETermsConditionsCheck', 'cb').subscribe((response): any => {
        //    if (response && response.length > 0)
        //        response[0].value == "1" ? this.checkTermsCondition() : console.log("WE T&C Disabled");
        //});
    }
    //Not using
    checkTermsCondition() {
        const partDealerId = TokenvalidationService.tokenInformation['PartDealerId'];
        this.termsConditionService.getTermsAndConditionFlag(partDealerId).subscribe(
            (response) => {
                if (response) {
                    const termsConditionflag = (response.termsAndConditionsFlag === 'N') ? true : false;
                    this.termsConditionService.setTermsConditionStatus(termsConditionflag);
                    if (termsConditionflag) {
                        this.router.navigate(['/home']);
                        let NgbModalOptions: NgbModalOptions = {
                            backdrop: 'static',
                            keyboard: false,
                            size: 'lg'
                        }
                        this.termsConditionMessage = response.termsAndConditionsMessage;
                        this.modalService.open(this.termAndConditionContent, NgbModalOptions);
                        this.renderer.addClass(this.document.body, 'blurBackground')
                    }
                }
            }
        )
    }
    //Not using
    accpetTermsCondition() {
        this.renderer.removeClass(this.document.body, 'blurBackground')
        const partDealerID = TokenvalidationService.tokenInformation['PartDealerId'];
        const attributeName = 'termsAndConditionsFlag';
        const attributeValue = 'Y';
        const user = TokenvalidationService.tokenInformation['UserName']
        if (partDealerID && attributeName && attributeValue && user) {
            this.termsConditionService.acceptTermsAndConditions(partDealerID, attributeName, attributeValue, user).subscribe(
                (response) => {
                    if (response) {
                        console.log(response);
                    }
                }
            )

        }
    }

    initGoogleAnalytics(menuName?: string): void {
        const googleAnalyticsTagId = environment['googleAnalyticsTagId'];
        const scriptId = 'tr-ga-head-script';
        if (googleAnalyticsTagId) {
            const existingScript = document.getElementById(scriptId);
            if (existingScript) {
                this.renderer.removeChild(document.head, existingScript);
            }
            const userName = TokenvalidationService.tokenInformation["UserName"];
            const userRole = TokenvalidationService.tokenInformation['Role']
                .map(role => role.toLowerCase())
                .join(',');
            const tenant = TokenvalidationService.tenant;
            const dealerName = TokenvalidationService.tokenInformation["OrgName"];
            const baseUrl =
                (window.location !== window.parent.location)
                    ? document.referrer
                    : document.location.href;

            const pageUrl = new URL(baseUrl).origin;
            menuName = menuName ?? window?.location?.pathname?.replace('/', '');
            const pathName = window?.location?.pathname?.replace('/', '');
            const gaHeadScript = this.renderer.createElement('script');
            this.renderer.setAttribute(gaHeadScript, 'id', scriptId);
            this.renderer.setAttribute(gaHeadScript, 'async', 'true');
            gaHeadScript.text = `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({
                  'gtm.start': new Date().getTime(),
                  event:'gtm.js'
                });
                var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),
                dl=l!='dataLayer'?'&l='+l:'';
                j.async=true;
                j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
                f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${googleAnalyticsTagId}');
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  user_role: '${userRole}',
                  tenant: '${tenant}',
                  dealer_name: '${dealerName}',
                  main_site: '${pageUrl}',
                  menu_name: '${menuName}',
                  previous_menu_name: '${pathName}',
                  GoogleAnalyticsId: '${googleAnalyticsTagId}'
                });
              `;
            this.renderer.appendChild(this.document.head, gaHeadScript);

            const bodyScriptId = 'tr-ga-body-script';
            const existingBodyScript = document.getElementById(bodyScriptId);
            if (existingBodyScript) {
                this.renderer.removeChild(document.body, existingBodyScript);
            }
            const gaBodyScript = this.renderer.createElement('noscript');
            this.renderer.setAttribute(gaBodyScript, 'id', bodyScriptId);
            const iframe = this.renderer.createElement('iframe');
            this.renderer.setAttribute(
                iframe,
                'src',
                `https://www.googletagmanager.com/ns.html?id=${googleAnalyticsTagId}`
            );
            this.renderer.setAttribute(iframe, 'height', '0');
            this.renderer.setAttribute(iframe, 'width', '0');
            this.renderer.setStyle(iframe, 'display', 'none');
            this.renderer.setStyle(iframe, 'visibility', 'hidden');
            this.renderer.appendChild(gaBodyScript, iframe);
            this.renderer.insertBefore(
                this.document.body,
                gaBodyScript,
                this.document.body.firstChild
            );
        }
    }

    }
